import type { Template } from "@/types";

export const PO_04_H0_V4: Template[] = [
{
    id: "po-04-h0v4-01",
    name: "PO 01 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 35, y: 205, width: 281, height: 444, rotation: 0, imageRotation: 0 },
            { id: "2", x: 324, y: 205, width: 281, height: 444, rotation: 0, imageRotation: 0 },
            { id: "3", x: 613, y: 205, width: 281, height: 444, rotation: 0, imageRotation: 0 },
            { id: "4", x: 902, y: 205, width: 281, height: 444, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-04-h0v4-02",
    name: "PO 02 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 191, width: 299, height: 470, rotation: 0, imageRotation: 0 },
        { id: "2", x: 307, y: 191, width: 299, height: 470, rotation: 0, imageRotation: 0 },
        { id: "3", x: 614, y: 191, width: 298, height: 470, rotation: 0, imageRotation: 0 },
        { id: "4", x: 920, y: 191, width: 298, height: 470, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-03",
    name: "PO 03 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 31, y: 213, width: 270, height: 425, rotation: 0, imageRotation: 0 },
        { id: "2", x: 309, y: 213, width: 269, height: 425, rotation: 0, imageRotation: 0 },
        { id: "3", x: 640, y: 213, width: 270, height: 425, rotation: 0, imageRotation: 0 },
        { id: "4", x: 918, y: 213, width: 269, height: 425, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-04",
    name: "PO 04 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_04.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 36, y: 172, width: 323, height: 506, rotation: 0, imageRotation: 0 },
            { id: "2", x: 366, y: 261, width: 209, height: 328, rotation: 0, imageRotation: 0 },
            { id: "3", x: 642, y: 261, width: 209, height: 328, rotation: 0, imageRotation: 0 },
            { id: "4", x: 858, y: 172, width: 323, height: 506, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-05",
    name: "PO 05 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 28, y: 140, width: 365, height: 570, rotation: 0, imageRotation: 0 },
            { id: "2", x: 401, y: 140, width: 179, height: 282, rotation: 0, imageRotation: 0 },
            { id: "3", x: 401, y: 429, width: 179, height: 281, rotation: 0, imageRotation: 0 },
            { id: "4", x: 732, y: 140, width: 363, height: 569, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-06",
    name: "PO 06 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 36, y: 40, width: 479, height: 753, rotation: 0, imageRotation: 0 },
        { id: "2", x: 523, y: 490, width: 195, height: 303, rotation: 0, imageRotation: 0 },
        { id: "3", x: 726, y: 490, width: 194, height: 303, rotation: 0, imageRotation: 0 },
        { id: "4", x: 928, y: 490, width: 194, height: 303, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-07",
    name: "PO 07 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 85, y: 81, width: 438, height: 688, rotation: 0, imageRotation: 0 },
            { id: "2", x: 643, y: 175, width: 318, height: 501, rotation: 0, imageRotation: 0 },
            { id: "3", x: 969, y: 81, width: 215, height: 341, rotation: 0, imageRotation: 0 },
            { id: "4", x: 969, y: 429, width: 215, height: 341, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-08",
    name: "PO 08 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_08.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 85, y: 81, width: 438, height: 688, rotation: 0, imageRotation: 0 },
            { id: "2", x: 643, y: 81, width: 215, height: 341, rotation: 0, imageRotation: 0 },
            { id: "3", x: 643, y: 429, width: 215, height: 340, rotation: 0, imageRotation: 0 },
            { id: "4", x: 866, y: 175, width: 318, height: 501, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-09",
    name: "PO 09 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 52, y: 79, width: 441, height: 693, rotation: 0, imageRotation: 0 },
        { id: "2", x: 726, y: 79, width: 440, height: 693, rotation: 0, imageRotation: 0 },
        { id: "3", x: 501, y: 79, width: 217, height: 343, rotation: 0, imageRotation: 0 },
        { id: "4", x: 501, y: 430, width: 217, height: 342, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-10",
    name: "PO 10 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 52, y: 79, width: 441, height: 693, rotation: 0, imageRotation: 0 },
        { id: "2", x: 501, y: 79, width: 440, height: 693, rotation: 0, imageRotation: 0 },
        { id: "3", x: 949, y: 79, width: 217, height: 343, rotation: 0, imageRotation: 0 },
        { id: "4", x: 949, y: 430, width: 217, height: 342, rotation: 0, imageRotation: 0 }
    ],
}
];